<template>
    <form id="onboarding-de" class="wrapper wrapper-tab-last" role="form" method="post" @submit.prevent="submit()">
        <header class="section-header">
            <figure>
                <svg width="109" height="101" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_3705_9815" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="11" height="14">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52664 1.52787L1.06633 5.76586C0.681993 6.42787 0.681993 7.51115 1.06633 8.17316L3.52664 12.4112C3.91097 13.0732 4.85427 13.6148 5.62285 13.6148H10.5435C10.0185 13.5402 9.68483 12.8486 8.64188 11.7582C7.71423 11.1984 5.55549 9.15864 4.9649 8.25661C4.27465 7.20235 3.97882 6.62632 3.86787 5.29016C3.70766 2.15214 5.62285 0.324219 5.62285 0.324219C4.85427 0.324219 3.91097 0.865857 3.52664 1.52787Z" fill="white"/>
                </mask>
                <g mask="url(#mask0_3705_9815)">
                <path d="M-17.002 -12.0586H31.7794V56.554H-17.002V-12.0586Z" fill="url(#paint0_linear_3705_9815)"/>
                </g>
                <mask id="mask1_3705_9815" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="2" width="13" height="12">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2555 8.44731C10.416 9.64244 8.92233 10.8934 7.60144 11.7442C4.77006 13.5681 3.85565 12.8627 3.62455 12.5652C4.03799 13.1745 4.90968 13.6565 5.62711 13.6565H10.4844C11.243 13.6565 12.1742 13.1175 12.5536 12.4589L14.9822 8.24232C14.9822 8.24232 16.3047 5.70319 9.83204 2.10547C13.9444 4.91049 11.9612 7.41062 11.2555 8.44731ZM3.62452 12.5645C3.60073 12.5294 3.57849 12.494 3.55786 12.4582C3.55786 12.4582 3.5763 12.5025 3.62452 12.5645Z" fill="white"/>
                </mask>
                <g mask="url(#mask1_3705_9815)">
                <path d="M-16.7063 -11.8867H31.4468V56.379H-16.7063V-11.8867Z" fill="url(#paint1_linear_3705_9815)"/>
                </g>
                <mask id="mask2_3705_9815" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="0" width="13" height="9">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.62068 0.324219C5.62068 0.324219 2.57436 1.33804 3.94912 5.90573C3.76663 2.91819 7.32669 3.40458 8.0036 4.09141C8.71439 3.42847 10.4096 3.07874 11.4073 3.68365C15.5804 6.27598 14.9758 8.22893 14.9758 8.22893C15.3552 7.56221 15.3552 6.47124 14.9758 5.80453L12.5471 1.53642C12.1678 0.869705 11.2366 0.324219 10.4779 0.324219H5.62068Z" fill="white"/>
                </mask>
                <g mask="url(#mask2_3705_9815)">
                <path d="M-16.7129 -12.1484H31.4402V56.9517H-16.7129V-12.1484Z" fill="url(#paint2_linear_3705_9815)"/>
                </g>
                <defs>
                <linearGradient id="paint0_linear_3705_9815" x1="-2.4026" y1="12.292" x2="5.31122" y2="14.7979" gradientUnits="userSpaceOnUse">
                <stop stop-color="#82F1C5"/>
                <stop offset="1" stop-color="#29AB77"/>
                </linearGradient>
                <linearGradient id="paint1_linear_3705_9815" x1="14.9049" y1="17.2245" x2="22.5616" y2="15.4905" gradientUnits="userSpaceOnUse">
                <stop stop-color="#2EC9FF"/>
                <stop offset="1" stop-color="#0091C3"/>
                </linearGradient>
                <linearGradient id="paint2_linear_3705_9815" x1="13.8166" y1="-6.617" x2="0.34617" y2="-7.90983" gradientUnits="userSpaceOnUse">
                <stop stop-color="#8B65E6"/>
                <stop offset="1" stop-color="#3E1E9E"/>
                </linearGradient>
                </defs>
                </svg> 
            </figure>
            <span class="new-headline-xlg text-centered">
                <template v-if="type === 'first'">Vielen Dank, dass Sie sich die Zeit genommen haben, das Formular auszufüllen.<br/>Wir freuen uns sehr, wenn Sie auch das nächste Formular in drei Monaten ausfüllen!</template>
                <template v-else>Vielen Dank, dass Sie sich die Zeit genommen haben, den Fragebogen auszufüllen.<br/>Wir freuen uns sehr, wenn Sie auch an der nächsten Umfrage in drei Monaten teilnehmen!</template>
            </span>
        </header>

        <section>
            <v-button href="/" position="center" size="lg" label="Zurück zur Hauptseite" full-width></v-button>
        </section>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            type: {
                type: String,
                required: true
            }
        },
        data() {
            return {

            }
        },

        mounted() {
            var data = {
                uuid: this.uuid,
                is_completed: true
            }

            axios
                .post('/rwe-study', data, {
                    headers: {
                        'Accept-Language': 'de'
                    }
                })
                .catch((e) => {
                    console.log(e.response)
                })
        },

        methods: {
        }
    }
</script>